import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class SelectedLeadsButton extends Component {
    
    state = {
        isOpen: false
    }


    buttonClick = () => {
        this.setState({ isOpen: !this.state.isOpen })
    }

    render() {
        const {selectedLeads, toggleModal, deselectAll} = this.props  
     
        let disabled = true;
        if(selectedLeads !== undefined){
            if(selectedLeads.length > 0)
                disabled = false;
        }

        if(disabled)
            this.state.isOpen = false;


        const className = ` ${this.state.isOpen ? 'open' : ''}`;       
        const {t} = this.props;

        // m-0 drops Spiris's `.dropdown { margin: 0 .8rem .8rem 0 }` so this lines up with the
        // button above it and the parent's gap-8 is the only vertical spacing.
        return <div className={'dropdown m-0' + className}>
                    <button type="button"
                        className="btn btn-default btn-sm dropdown-toggle"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded={this.state.isOpen ? 'true' : 'false'}
                        onClick={() => { this.setState({ isOpen: !this.state.isOpen }) }}
                        disabled={disabled}
                    >
                        {t('selectedleadbutton.selected')}
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li><a onClick={() => toggleModal("showCloseModal")}> {t('selectedleadbutton.close')}</a></li>
                        <li><a onClick={() => deselectAll()}> {t('selectedleadbutton.deselect')}</a></li>
                    </ul>
                </div>
    }
}

export default withTranslation()(SelectedLeadsButton);